import { Form, Offcanvas, Button, InputGroup } from "react-bootstrap";
import { FiPlusSquare } from "react-icons/fi";
import { GoTrash } from "react-icons/go";

const ConfigureDomainRestriction = ({
  show,
  hide,
  title,
  widgetDomainRestrictionSettings,
  setWidgetDomainRestrictionSettings,
  updateWidgetDomainRestrictionSettings,
  toggleWidgetDomainRestrictionSettings,
  initialDomainRestrictionSettings
}) => {

  const addRule = (type) => {
    setWidgetDomainRestrictionSettings((prev) => ({
      ...prev,
      [type]: [...prev[type], ""],
    }));
  };

  const removeRule = (type, index) => {
    setWidgetDomainRestrictionSettings((prev) => {
      const updated = prev[type].filter((_, i) => i !== index);

      return {
        ...prev,
        [type]: updated.length ? updated : [""],
      };
    });
  };
  return (
    <Offcanvas show={show} onHide={hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form>
          <h6>Domain Restriction</h6>
          <p style={{ fontSize: 12 }}>
            By default, the code will work on all the domains and URLs where it has been inserted. To show or hide the widget on one or more specific domain or URLs, enable this functionality and specify the rule.
          </p>
          <Form.Check
            type="switch"
            id="show-toggle"
            style={{ fontSize: 12 }}
            label="Show widget only on specific domains and/or URLs"
            checked={widgetDomainRestrictionSettings?.showEnabled}
            onChange={(e) =>
              toggleWidgetDomainRestrictionSettings("showEnabled", e.target.checked)
            }
            className="mb-2"
          />
          {widgetDomainRestrictionSettings?.showEnabled &&
            widgetDomainRestrictionSettings?.showDomains.map((rule, index) => (
              <InputGroup className="mb-2" key={`show-${index}`}>
                <Form.Control
                  size="sm"
                  placeholder="example.com or https://example.com/page"
                  value={rule}
                  onChange={(e) =>
                    updateWidgetDomainRestrictionSettings("showDomains", index, e.target.value)
                  }
                />
                <InputGroup.Text
                  role="button"
                  onClick={() =>
                    removeRule("showDomains", index)
                  }
                >
                  <GoTrash className="text-danger" size={12} />
                </InputGroup.Text>
              </InputGroup>
            ))}

          {widgetDomainRestrictionSettings?.showEnabled && (
            <div
              className="hstack gap-2 CP mb-3"
              style={{ fontSize: 12 }}
              onClick={() => addRule("showDomains")}
            >
              <FiPlusSquare />
              Add More
            </div>
          )}
          <Form.Check
            type="switch"
            id="hide-toggle"
            style={{ fontSize: 12 }}
            label="Hide widget on specific domains and/or URLs"
            checked={widgetDomainRestrictionSettings?.hideEnabled}
            onChange={(e) =>
              toggleWidgetDomainRestrictionSettings("hideEnabled", e.target.checked)
            }
            className="mb-2"
          />
          {widgetDomainRestrictionSettings?.hideEnabled &&
            widgetDomainRestrictionSettings?.hideDomains.map((rule, index) => (
              <InputGroup className="mb-2" key={`hide-${index}`}>
                <Form.Control
                  size="sm"
                  placeholder="example.com or https://example.com/page"
                  value={rule}
                  onChange={(e) =>
                    updateWidgetDomainRestrictionSettings("hideDomains", index, e.target.value)
                  }
                />
                <InputGroup.Text
                  role="button"
                  onClick={() =>
                    removeRule("hideDomains", index)
                  }
                >
                  <GoTrash className="text-danger" size={12} />
                </InputGroup.Text>
              </InputGroup>
            ))}
          {widgetDomainRestrictionSettings?.hideEnabled && (
            <div
              className="hstack gap-2 CP mb-3"
              style={{ fontSize: 12 }}
              onClick={() => addRule("hideDomains")}
            >
              <FiPlusSquare />
              Add More
            </div>
          )}
          {widgetDomainRestrictionSettings?.domainRestriction &&
            <div className="d-flex justify-content-end gap-2 mt-4">
              <Button
                size="sm"
                variant="outline-danger"
                onClick={() => setWidgetDomainRestrictionSettings(initialDomainRestrictionSettings)}
              >
                Reset
              </Button>
            </div>
          }
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ConfigureDomainRestriction;
